import { Toolbar } from '@mui/material'
import react, { createContext, useEffect, useState } from 'react'
import { getPlacementList } from '../../store/adminActions'
import { useAppDispatch, useAppSelector } from '../../store/hooks/hooks'
import Navbar from '../navbar/navbar'
import Dashboard from './dashboard/dashboard'
import Meetings from './meetings/meetings'
import RequestTab from './RequestTab/requestTab'
import Scheduler from './scheduler/scheduler'
import SideNav from './sideNav/sideNav'
import StudentContainer from './Students/students'


export const NavigationContext = createContext({
    content: "Dashboard",
    assignContent: (e: any) => { }
});

const AdminDashboard = () => {
    const dispatch = useAppDispatch()
    const placementList = useAppSelector((state: any) => state.admin.placements)
    const [content, setContent] = useState("Dashboard")
    const fetchPlacementList = async () => {
        await dispatch(getPlacementList())
    }
    const assignContent = (e:string) => {
        setContent(e)
    }
    useEffect(() => {
        fetchPlacementList()
    }, [])
    const switchContent = () => {
        switch (content) {
            case 'Students':
                return <StudentContainer></StudentContainer>
            case 'Scheduler':
                return <Scheduler placementList={placementList}></Scheduler>
            case 'Requests':
                return <RequestTab></RequestTab>
            case 'Dashboard':
                return <Dashboard></Dashboard>
            case 'Meetings':
                return <Meetings></Meetings>
        }
    }

    return (
        <NavigationContext.Provider value={{ content, assignContent }}>
            <Navbar></Navbar>
            <Toolbar />
            <div className='flex'>
                <SideNav  navbarReset={() => {
                    
                }}></SideNav>
                {
                    placementList && switchContent()
                }
            </div>
        </NavigationContext.Provider>

    )

}
export default AdminDashboard